<div class="container-fluid mt-3">
    <!-- お知らせ (自分宛ての通知): カテゴリ別タブ + HTML 本文。通知が無くてもカードは表示する。 -->
    <div class="card">
        <div class="card-header d-flex align-items-center">
            <strong>{{ 'kobeac.notices' | transloco }}</strong>
            <!-- 非表示の通知を表示/隠す トグル -->
            <button *ngIf="hiddenCount > 0 || showHidden" class="btn btn-sm btn-link ml-auto p-0" (click)="toggleShowHidden()">
                {{ showHidden ? ('kobeac.hide_hidden' | transloco) : ('kobeac.show_hidden_n' | transloco: {count: hiddenCount}) }}
            </button>
        </div>
        <div class="card-body">
            <!-- 通知なし -->
            <div *ngIf="notifications.length === 0" class="text-muted">{{ 'kobeac.no_notices' | transloco }}</div>

            <ng-container *ngIf="notifications.length > 0">
                <!-- カテゴリタブ -->
                <ul class="nav nav-tabs mb-3">
                    <li class="nav-item" *ngFor="let t of tabs">
                        <a class="nav-link" href="javascript:void(0)" [class.active]="activeTab === t" (click)="selectTab(t)">
                            {{ t === 'すべて' ? ('common.all' | transloco) : t }} <span class="badge badge-light">{{ countOf(t) }}</span>
                        </a>
                    </li>
                </ul>

                <!-- 選択タブの通知 (件数が増えても画面を占有しないよう高さ固定でスクロール) -->
                <div class="notification-list" style="max-height:45vh; overflow-y:auto">
                    <div class="mb-3" *ngFor="let n of visibleNotifications" [style.opacity]="n.dismissed ? '0.55' : '1'">
                        <div class="d-flex align-items-baseline">
                            <span class="badge badge-info mr-2">{{ n.category || 'お知らせ' }}</span>
                            <strong>{{ n.subject }}</strong>
                            <small class="text-muted ml-auto mr-2">{{ formatDateTime(n.notifyDate) }}</small>
                            <button *ngIf="!n.dismissed" class="btn btn-sm btn-link p-0 text-muted" [title]="'kobeac.hide_title' | transloco" (click)="dismiss(n)">{{ 'kobeac.hide' | transloco }}</button>
                            <button *ngIf="n.dismissed" class="btn btn-sm btn-link p-0" [title]="'kobeac.unhide_title' | transloco" (click)="undismiss(n)">{{ 'kobeac.unhide' | transloco }}</button>
                        </div>
                        <div class="text-body notification-content" [innerHTML]="n.safeContent"></div>
                        <hr class="my-2">
                    </div>
                    <div *ngIf="visibleNotifications.length === 0" class="text-muted">{{ 'kobeac.no_notices_in_category' | transloco }}</div>
                </div>
            </ng-container>
        </div>
    </div>

    <!-- 書類 (旧「書類」メニューをダッシュボードに統合。データが無くても空状態で表示) -->
    <kobeac-document [embedded]="true"></kobeac-document>
</div>
